module.exports = __webpack_public_path__ + "static/media/cja-learning-logo.0a626fc9.png";